import { service } from "../utils/request";

//  活动中心
export function activeList(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/index",
    method: "post",
    data: data
  });
}
export function deleteactive(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/del",
    method: "post",
    data: data
  });
}
export function addactive(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/add",
    method: "post",
    data: data
  });
}
export function editactive(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/edit",
    method: "post",
    data: data
  });
}
export function detailactive(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/detail",
    method: "post",
    data: data
  });
}
// 商家参加活动列表
export function applicatList(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/merch_list",
    method: "post",
    data: data
  });
}
// 商家参加活动列表
export function applicatAudit(data) {
  return service({
    url: "fullreduction/agent.Fullreductionactive/merch_auth",
    method: "post",
    data: data
  });
}

// 大转盘活动添加
export function addAwardActivty(data) {
  return service({
    url: "bigwheel/agent.index/add",
    method: "post",
    data: data
  });
}

// 转盘开启关闭
export function setTurnStatus(data) {
  return service({
    url: "bigwheel/agent.index/open_active",
    method: "post",
    data: data
  });
}
